import { Grid } from "@mui/material";
import React from "react";
import { Floor } from "src/interfaces/IZone";
import Select, { Item } from "../../../UI/Select";
import { Sorter } from "../utils";

export default function FloorSelector({
  selectedFloors,
  onSelect,
  floors,
}: {
  selectedFloors: Floor[];
  onSelect: (floors: Floor[]) => void;
  floors: Floor[];
}) {
  const handleSelected = (selected: string[]) => {
    onSelect(
      selected.map(
        (name) => floors.find((floor) => floor.name === name) as Floor
      )
    );
  };
  return (
    <Grid container item sm={12} md={3}>
      <Select
        label="Floor"
        sx={{ flex: "1 1 100%" }}
        multiple
        value={selectedFloors.map((floor) => floor.name)}
        onChange={(selected: string[]) => handleSelected(selected)}
      >
        {floors.sort(Sorter.floor).map((floor: Floor) => (
          <Item key={floor.name} value={floor.name} showCheckbox>
            {floor.name}
          </Item>
        ))}
      </Select>
    </Grid>
  );
}
